import { browser } from '$app/environment';
import { ENVIRONMENTS } from '$lib/utils/constants';

/**
 * @returns {typeof ENVIRONMENTS[keyof typeof ENVIRONMENTS]}
 */
export function getEnvironment() {
	if (typeof window === 'undefined' || !browser) {
		return ENVIRONMENTS.PRODUCTION;
	}

	const hostname = window.location.hostname;

	if (
		hostname.includes('localhost') ||
		hostname.includes('review') ||
		hostname.includes('web.dev')
	) {
		return ENVIRONMENTS.DEVELOPMENT;
	}

	if (hostname.includes('stage')) {
		return ENVIRONMENTS.STAGING;
	}

	return ENVIRONMENTS.PRODUCTION;
}
